import { useSelector } from 'react-redux';
import { getTotalPayableAfterCredits, getPaymentMode, getPayableLaterCashAmount, getPointsAmount } from 'store/checkout/checkoutSelectors';
import { MIN_POINTS_AMOUNT } from 'config';

import usePointsConverters from 'hooks/points/usePointsConverters';
import { getPointsBalance } from 'store/user/userSelectors';
import { PAYMENT_MODES } from 'lib/enums/payment';

const usePointsRedemptionAvailable = () => {
  const { convertCashToPoints } = usePointsConverters();
  const totalPayableAfterCredits = useSelector(getTotalPayableAfterCredits);
  const totalPayableLater = useSelector(getPayableLaterCashAmount);
  const pointsBalance = useSelector(getPointsBalance);
  const paymentMode = useSelector(getPaymentMode);
  const pointsAmount = useSelector(getPointsAmount);

  let isPayableLessThanMinPoints;

  if (paymentMode === PAYMENT_MODES.DEPOSIT) {
    const totalPayableLaterInPoints = convertCashToPoints({ cash: totalPayableLater });
    isPayableLessThanMinPoints = totalPayableLaterInPoints.lessThan(MIN_POINTS_AMOUNT);
  } else {
    const totalPayableAfterCreditsInPoints = convertCashToPoints({ cash: totalPayableAfterCredits });
    isPayableLessThanMinPoints = totalPayableAfterCreditsInPoints.lessThan(MIN_POINTS_AMOUNT);
  }

  const isPointsPayAvailable =
    pointsAmount.greaterThan(0) || (pointsBalance.greaterThanOrEqualTo(MIN_POINTS_AMOUNT) && !isPayableLessThanMinPoints);

  const isBalanceLessThanMinPoints = pointsBalance.lessThan(MIN_POINTS_AMOUNT);

  return { isPointsPayAvailable, isBalanceLessThanMinPoints, isPayableLessThanMinPoints };
};

export default usePointsRedemptionAvailable;
